module.exports = __webpack_public_path__ + "static/media/pc_icon_e_follow_normal.bf2e3ec4.svg";